/* WALLTRAUD® Bildmontage – event delegation works in Theme Editor too. */
(() => {
  if (window.__wtMountLightboxV2) return;
  window.__wtMountLightboxV2 = true;
  let lastTrigger = null;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-wt-mount-open]');
    if (trigger) {
      const modal = trigger.closest('[data-wt-mount]')?.querySelector('dialog.wt-mount__dialog');
      if (modal && !modal.open && typeof modal.showModal === 'function') {
        lastTrigger = trigger;
        modal.showModal();
        modal.querySelector('[data-wt-mount-close]')?.focus();
      }
      return;
    }
    const close = event.target.closest('[data-wt-mount-close]');
    if (close) close.closest('dialog')?.close();
    else if (event.target.matches('dialog.wt-mount__dialog')) event.target.close();
  });
  document.addEventListener('close', (event) => {
    if (!event.target.matches('dialog.wt-mount__dialog')) return;
    if (lastTrigger?.isConnected) lastTrigger.focus();
    lastTrigger = null;
  }, true);
})();
